var _text, _text2, _line, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaneBarata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 200",
    width: 800,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 120,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 88,
    fontWeight: 700,
    fill: "#252b33",
    letterSpacing: -2
  }, "Dane")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 264,
    y: 120,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 88,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: -2
  }, "Barata")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 136,
    x2: 760,
    y2: 136,
    stroke: "#ffffff",
    strokeWidth: 1.2,
    opacity: 0.18
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 164,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 400,
    fill: "#aaaaaa",
    letterSpacing: 6
  }, "CFO  \xB7  ENTREPRENEUR  \xB7  INVESTOR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaneBarata);
export default __webpack_public_path__ + "static/media/dane_barata.9deef51a95bb6a5208ad8c2f40dca5cb.svg";
export { ForwardRef as ReactComponent };